module.exports = __webpack_public_path__ + "static/media/smith.dbd8d4cb.webp";